import * as React from "react";
import { useTheme, styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import banner1 from "../../../assets/banner/banner11.jpg";
import banner2 from "../../../assets/banner/banner12.jpg";
import Container from "../../../common/Container";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const ColorButton = styled(Button)(() => ({
  color: "#fff",
  width: 180,
  height: 55,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#9DCC49",
  borderColor: "#9DCC49",
  "&:hover": {
    color: "#fff",
    backgroundColor: "#317ABE",
    borderColor: "#317ABE",
  },
}));

const images = [
  {
    label: "banner_image1",
    imgPath: banner1,
    title: "Empowering Nigeria’s Marine and Coastal Future",
    subtitle:
      "We design and deliver practical programs that restore marine and coastal ecosystems, strengthen blue livelihoods, and enable lasting prosperity for Nigeria’s coastal communities.",
  },
  {
    label: "banner_image2",
    imgPath: banner2,
    title: "Building a Smarter Blue Economy for Nigeria",
    subtitle:
      "From mangroves to fisheries, from coastal youth to women-led enterprises, we work at the intersection of nature, livelihoods, and sustainable growth.",
  },
];

function Banner() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ flexGrow: 1 }} marginTop={{ xs: "15%", sm: "0%" }}>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={5000}
      >
        {images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box>
                <Box
                  component="img"
                  height={{ xs: "110vh", sm: "900px" }}
                  display={{ xs: "none", sm: "block" }}
                  sx={{
                    objectFit: "cover",
                    position: "relative",
                    overflow: "hidden",
                    width: "100%",
                  }}
                  src={step.imgPath}
                  alt={step.label}
                />
                <Box
                  paddingBottom={"3%"}
                  position={"absolute"}
                  top={{ xs: "15%", sm: "30%" }}
                  marginLeft={{ xs: "0%", sm: "0%" }}
                  width={{ xs: "100%", sm: "100%" }}
                  display={{ xs: "none", sm: "block" }}
                >
                  {" "}
                  <Container>
                    <Typography
                      variant="h2"
                      color="#fff"
                      fontWeight={800}
                      padding={{ xs: "0%", sm: "1%" }}
                      textAlign={"left"}
                    >
                      {step.title}
                    </Typography>
                    <Typography
                      variant="h6"
                      color="#fff"
                      fontWeight={400}
                      padding={{ xs: "0%", sm: "1%" }}
                      textAlign={"left"}
                    >
                      {step.subtitle}
                    </Typography>
                    <Box marginTop={"2%"}>
                      <ColorButton
                        component={"a"}
                        variant="contained"
                        size="medium"
                        href={"/about-us"}
                      >
                        Read More
                      </ColorButton>
                    </Box>
                  </Container>
                </Box>
                <Box
                  paddingBottom={"3%"}
                  paddingTop={{ xs: "45%", sm: "32%" }}
                  marginLeft={{ xs: "0%", sm: "2%" }}
                  width={{ xs: "100%", sm: "85%" }}
                  display={{ xs: "block", sm: "none" }}
                >
                  {" "}
                  <Typography
                    variant="h3"
                    color="#fff"
                    fontWeight={800}
                    padding={{ xs: "0% 2% 0% 5%", sm: "1% 1% 1% 18%" }}
                    textAlign={"left"}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    variant="h6"
                    color="#fff"
                    fontWeight={400}
                    padding={{ xs: "0% 2% 0% 5%", sm: "1% 3% 1% 2%" }}
                    textAlign={"left"}
                  >
                    {step.subtitle}
                  </Typography>
                  <Box margin={{ xs: "7%", sm: "3%" }}>
                    <ColorButton
                      component={"a"}
                      variant="contained"
                      size="medium"
                      href={"/about-us"}
                    >
                      Read More
                    </ColorButton>
                  </Box>
                </Box>
              </Box>
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
    </Box>
  );
}

export default Banner;
